import { render } from "./ModalPaymentFail.vue?vue&type=template&id=356aff8b&scoped=true&ts=true"
import script from "./ModalPaymentFail.vue?vue&type=script&lang=ts"
export * from "./ModalPaymentFail.vue?vue&type=script&lang=ts"

import "./ModalPaymentFail.vue?vue&type=style&index=0&id=356aff8b&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356aff8b"]])

export default __exports__